<template>

	<div>
        <div class="row">
			<h1 class="page-header">
            Club&nbsp;Records
			<span class="pull-right">
			<a class=" btn btn-primary  noprint" href="/club/club_records/import">Import Records</a>
			<button class=" btn btn-primary  noprint" v-on:click="showNewRecordForm" v-show="!addMode">Add New Record</button>
            <button class=" btn btn-danger  noprint" v-on:click="hideNewRecordForm" v-show="addMode">Cancel</button>
			</span>
			</h1>
    </div>

		<create-club-record v-on:savedrecord="" v-show="addMode"></create-club-record>

		<club-records-list can_manage_records gender="Male" course="SC" title="Male SC Records"></club-records-list>
		<club-records-list can_manage_records gender="Female" course="SC" title="Female SC Records"></club-records-list>
		<club-records-list can_manage_records gender="Male" course="LC" title="Male LC Records"></club-records-list>
		<club-records-list can_manage_records gender="Female" course="LC" title="Female LC Records"></club-records-list>


	</div>

</template>

<script>
	export default {
		data: function () {
				return {
					addMode: false
				}
		},
		computed: {
		},
		mounted() {
				console.log('Club Record Page component mounted.');
		},
		methods: {
			showNewRecordForm() {
				this.addMode = true;
			},
			hideNewRecordForm() {
				this.addMode = false;
			}
		}
	}
</script>